import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ForgotPasswordState } from "../../types";
import { axiosObj } from "../../../config/apiClients";

const initialState: ForgotPasswordState = {
  isLoading: false,
  email: '',
  status: ''
}

export const sendResetEmail = createAsyncThunk(
  "/auth/resendOneTimePassword",
  async (email: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/auth/resendOneTimePassword', { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  "/auth/verifyOneTimePassword",
  async ({ email, passcode }: { email: string; passcode: string }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/auth/verifyOneTimePassword', { email, passcode });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updatePassword = createAsyncThunk(
  "/auth/addNewPassword",
  async ({ email, password }: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/auth/addNewPassword', { email, password });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload
    }
  },
  extraReducers(builder) {
    builder
      .addCase(sendResetEmail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendResetEmail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = action.payload.status;
      })
      .addCase(sendResetEmail.rejected, (state) => {
        state.isLoading = false;
        state.status = '';
      })
      .addCase(verifyOTP.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = action.payload.status;
      })
      .addCase(verifyOTP.rejected, (state) => {
        state.isLoading = false;
        state.status = '';
      })
      .addCase(updatePassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = action.payload.status;
      })
      .addCase(updatePassword.rejected, (state) => {
        state.isLoading = false;
        state.status = '';
      });
  },
});

export const { setEmail, } = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;